<template>
  <v-app>
    <section class="portfolio" id="portfolio">
      <div class="top-right-separator hidden-xs"></div>
      <div class="container">
        <div class="section-title-parralax">
          <div class="process-numbers" style="text-align: center;">PORTFOLIO</div>
          <h2>portfolio</h2>
          <p class="module-subtitle" style="color: black;">Here's some of my work.</p>
        </div>

        <!-- categories -->
        <div class="col-md-3">
          <div class="row categories-grid">
            <nav class="categories">
              <ul class="portfolio_filter">
                <li><a href="" class="active" data-filter="*">all</a></li>
                <li><a href="" data-filter=".fullstack">Full-Stack</a></li>
                <li><a href="" data-filter=".node">NodeJS</a></li>
                <li><a href="" data-filter=".express">ExpressJS</a></li>
                <li><a href="" data-filter=".mongo">MongoDB</a></li>
                <li><a href="" data-filter=".vue">VueJs</a></li>
                <li><a href="" data-filter=".angular">Angular</a></li>
                <li><a href="" data-filter=".vuetify">Vuetify</a></li>
                <li><a href="" data-filter=".bootstrap">Bootstrap</a></li>
                <li><a href="" data-filter=".wordpress">Wordpress</a></li>
                <li><a href="" data-filter=".sass">SASS</a></li>
                <li><a href="" data-filter=".bulma">Bulma</a></li>
                <li><a href="" data-filter=".next">NextJS</a></li>
                <li><a href="" data-filter=".react">React</a></li>
                <li><a href="" data-filter=".supabase">Supabase</a></li>
                <li><a href="" data-filter=".stripe">Stripe</a></li>
                <li><a href="" data-filter=".firebase">Firebase</a></li>
                <li><a href="" data-filter=".tailwind">TailwindCSS</a></li>
              </ul>
            </nav>
          </div>
        </div>

        <!-- all works -->
        <div class="col-md-9">
          <div class="row portfolio_container">
            <template v-for="project in projects">
              <div :key="project.id" :class="['col-md-4', project.classes]">
                <div class="portfolio_item work-grid">
                  <img :src="project.images[0].src" alt="image">
                  <div class="portfolio_item_hover">
                    <div class="item_info">
                      <span>{{ project.name }}</span>
                      <v-btn flat @click.stop="activeProject = project">view</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- shared dialog -->
      <v-flex xs12>
        <v-dialog v-model="dialogOpen" max-width="1000px" style="background-color: white;">
          <v-card flat class="modal-card" v-if="activeProject">
            <v-layout row wrap>
              <v-flex xs12 md7 class="modal-carousel-side">
                <v-carousel hide-delimiters class="modal-carousel">
                  <v-carousel-item v-for="(image, i) in activeProject.images" :key="i"
                    :src="image.src"></v-carousel-item>
                </v-carousel>
              </v-flex>
              <v-flex xs12 md5 class="modal-info-side">
                <h4 class="modal-title">{{ activeProject.title }}</h4>
                <p class="portP modal-subtitle">{{ activeProject.subtitle }}</p>
                <p class="portP" v-if="activeProject.demo">
                  For demo, log in as <strong>{{ activeProject.demo.user }}</strong><br>
                  Password: <strong>{{ activeProject.demo.password }}</strong>
                </p>
                <p class="portP">{{ activeProject.description }}</p>
                <p class="portP"><span class="tools-label">Tools: </span>{{ activeProject.tools }}</p>
                <div class="modal-actions">
                  <a class="view-site-btn" :href="activeProject.url" target="_blank">VIEW SITE</a>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-dialog>
      </v-flex>
    </section>
  </v-app>
</template>

<script>
export default {
  name: "Portfolio",
  data() {
    return {
      activeProject: null,
      projects: [
        {
          id: 1,
          name: "Bashor & Legendre",
          classes: "vue node fullstack",
          url: "http://www.blcpas.com/#/",
          title: "Bashor & Legendre, LLP",
          subtitle: "Certified Public Accountants (CPAs)",
          description: "Bashor & Legendre, LLP, Certified Public Accountants (CPAs), is a full service accounting, tax and consulting firm.",
          tools: "VueJs + NodeJS + Vuetify",
          images: [
            { src: "/static/assets/img/bash1.png" },
            { src: "/static/assets/img/bash2.png" },
            { src: "/static/assets/img/bashfooter.png" },
            { src: "/static/assets/img/bashindustries.png" },
            { src: "/static/assets/img/bashmobile.png" }
          ]
        },
        {
          id: 2,
          name: "Quickr Lists",
          classes: "mongo angular express node bulma sass fullstack",
          url: "http://quickrlists.com/",
          title: "Quickr Lists",
          subtitle: "Easy task management",
          description: "Quickr Lists is a task list for everyday use. It is truly usable with great user experience.",
          tools: "Angular + NodeJS + ExpressJS + MongoDB",
          demo: { user: "demo@quickrlists.com", password: "test1234" },
          images: [
            { src: "/static/assets/img/quickrlists1.png" },
            { src: "/static/assets/img/quickrlists2.png" },
            { src: "/static/assets/img/quickrlists3.png" }
          ]
        },
        {
          id: 3,
          name: "Cyber Dream VR",
          classes: "wordpress",
          url: "https://www.cyberdreamvr.com/",
          title: "Cyber Dream VR",
          subtitle: "VR Game Development Studio",
          description: "Cyber Dream is a VR game development studio, employing professionals and game enthusiasts fascinated with the capabilities of virtual reality.",
          tools: "Wordpress",
          images: [
            { src: "/static/assets/img/cyber1.png" },
            { src: "/static/assets/img/cyber2.png" },
            { src: "/static/assets/img/cyber3.png" }
          ]
        },
        {
          id: 4,
          name: "SHEA BATH & BODY",
          classes: "vue bootstrap snipcart node express",
          url: "https://sheabathandbody.com/",
          title: "Shea Bath & Body",
          subtitle: "Your Life. Your Body. Your Skin",
          description: "Shea Bath & Body is a handmade bath products company located in Tampa, Florida. This wife and husband team is dedicated to making high quality vegan and ecofriendly items that work great and smell amazing at the same time.",
          tools: "VueJS + HTML5 + Bootstrap4 + JQuery",
          images: [
            { src: "/static/assets/img/shea1.png" },
            { src: "/static/assets/img/shea2.png" },
            { src: "/static/assets/img/shea3.png" },
            { src: "/static/assets/img/shea4.png" },
            { src: "/static/assets/img/shea5.png" }
          ]
        },
        {
          id: 5,
          name: "DWERVE",
          classes: "vue vuetify",
          url: "https://dwerve.com",
          title: "Dwerve",
          subtitle: "Tower Defense Dungeon Crawler",
          description: "Dwerve is a singleplayer tower-defense dungeon crawler RPG in which the player assumes the role of a dwarven Warsmith, or war-engineer, named Dwerve.",
          tools: "VueJS + Bootstrap4 + JQuery",
          images: [
            { src: "/static/assets/img/dwerve1.png" },
            { src: "/static/assets/img/dwerve2.png" },
            { src: "/static/assets/img/dwerve3.png" }
          ]
        },
        {
          id: 6,
          name: "HALF HUMAN GAMES",
          classes: "vue bulma",
          url: "https://halfhumangames.com",
          title: "Half Human Games",
          subtitle: "Indie Game Studio",
          description: "Two independent game developers, PJ Legendre and Peter Milko formed Half Human Games around an idea for dungeon crawler RPG that ditched hack n' slash and turned-based combat for tower defense style combat.",
          tools: "VueJs + Bulma",
          images: [
            { src: "/static/assets/img/hhg.png" }
          ]
        },
        {
          id: 7,
          name: "Ollert",
          classes: "vue mongo vuetify express node fullstack",
          url: "https://ollert.vercel.app/",
          title: "Ollert",
          subtitle: "A Trello Clone",
          description: "",
          tools: "VueJs + NodeJS + ExpressJS + MongoDB",
          demo: { user: "ollert", password: "test1234" },
          images: [
            { src: "/static/assets/img/ollert1.png" },
            { src: "/static/assets/img/ollert2.png" },
            { src: "/static/assets/img/ollert3.png" },
            { src: "/static/assets/img/ollert4.png" }
          ]
        },
        {
          id: 8,
          name: "I EAT FOOD",
          classes: "bootstrap",
          url: "https://i-eat-food.herokuapp.com/index.html",
          title: "I EAT FOOD",
          subtitle: "Foodie blog",
          description: "A small project designed for a food enthusiast.",
          tools: "HTML5 + Bootstrap4 + SASS",
          images: [
            { src: "/static/assets/img/foodie1.png" },
            { src: "/static/assets/img/foodie3.png" },
            { src: "/static/assets/img/foodie4.png" },
            { src: "/static/assets/img/foodie6.png" }
          ]
        },
        {
          id: 9,
          name: "FAESAL",
          classes: "vue bootstrap",
          url: "https://faesalshehab.herokuapp.com/#/",
          title: "Faesal Shehab",
          subtitle: "Online Portfolio",
          description: "A portfolio designed for a mechanical engineer.",
          tools: "VueJS + HTML5 + Bootstrap4 + JQuery",
          images: [
            { src: "/static/assets/img/fas1.png" },
            { src: "/static/assets/img/fas2.png" },
            { src: "/static/assets/img/fas3.png" },
            { src: "/static/assets/img/fas4.png" }
          ]
        },
        {
          id: 10,
          name: "BRANDEN",
          classes: "vue bootstrap",
          url: "https://branden-portfolio.herokuapp.com/#/",
          title: "Branden Jones",
          subtitle: "Online Portfolio",
          description: "A portfolio designed for a mechanical engineer.",
          tools: "VueJS + HTML5 + Bootstrap4 + JQuery",
          images: [
            { src: "/static/assets/img/jones1.png" },
            { src: "/static/assets/img/jones2.png" },
            { src: "/static/assets/img/jones3.png" },
            { src: "/static/assets/img/jones4.png" }
          ]
        },
        {
          id: 11,
          name: "TASTE OF SPAIN",
          classes: "vue bootstrap",
          url: "https://taste-of-spain.herokuapp.com/",
          title: "Taste of Spain",
          subtitle: "Gourmet On-Site Cooking",
          description: "Taste of Spain is a full service catering company, serving the Tampa Bay Area and beyond.",
          tools: "VueJS + HTML5 + Bootstrap4 + JQuery",
          images: [
            { src: "/static/assets/img/taste1.png" },
            { src: "/static/assets/img/taste2.png" },
            { src: "/static/assets/img/taste3.png" },
            { src: "/static/assets/img/taste4.png" }
          ]
        },
        {
          id: 12,
          name: "malaika",
          classes: "vuetify vue",
          url: "http://malaikakunle2.herokuapp.com/",
          title: "Malaika",
          subtitle: "Personal Project",
          description: "Portfolio Concept",
          tools: "VueJS + Vuetify + BootstrapVue",
          images: [
            { src: "/static/assets/img/port1.png" },
            { src: "/static/assets/img/port2.png" }
          ]
        },
        {
          id: 13,
          name: "Corgi Messageboard",
          classes: "mongo vue express node bulma fullstack",
          url: "https://messageboard.malaika787.now.sh/",
          title: "Corgi Messageboard",
          subtitle: "An online community for corgi enthusiasts",
          description: "Corgi Messageboard is an online community for corgi enthusiasts, shelters, rescue organizations, volunteers, fosters, and adopters to share information.",
          tools: "Bulma + NodeJS + ExpressJS + MongoDB",
          images: [
            { src: "/static/assets/img/corgi1.png" },
            { src: "/static/assets/img/corgi2.png" },
            { src: "/static/assets/img/corgi3.png" }
          ]
        },
        {
          id: 14,
          name: "MeetLoop",
          classes: "next react supabase stripe tailwind fullstack",
          url: "https://meetloop-seven.vercel.app/",
          title: "MeetLoop",
          subtitle: "Community Group & Event Management",
          description: "MeetLoop is a platform for building and managing recurring communities. Create groups, schedule sessions, collect payments, track attendance, and email members — all in one place.",
          tools: "NextJS + React + Supabase + Stripe + TailwindCSS + TypeScript",
          images: [
            { src: "/static/assets/img/meetloop1.png" },
            { src: "/static/assets/img/meetloop2.png" },
            { src: "/static/assets/img/meetloop3.png" },
            { src: "/static/assets/img/meetloop4.png" },
            { src: "/static/assets/img/meetloop5.png" },
            { src: "/static/assets/img/meetloop6.png" },
            { src: "/static/assets/img/meetloop7.png" }

          ]
        },
        {
          id: 15,
          name: "Busy Bee Social",
          classes: "next react firebase tailwind fullstack",
          url: "https://social-media-app-iota-beryl.vercel.app/",
          title: "Busy Bee Social",
          subtitle: "Social Networking Platform",
          description: "Busy Bee Social is a platform for connecting people with similar interests and hobbies.",
          tools: "NextJS + React + Firebase + TailwindCSS + TypeScript",
          images: [
            { src: "/static/assets/img/social1.png" },
            { src: "/static/assets/img/social2.png" },
            { src: "/static/assets/img/social3.png" }
          ]

        }

      ]
    };
  },
  computed: {
    dialogOpen: {
      get() { return this.activeProject !== null; },
      set(val) { if (!val) this.activeProject = null; }
    }
  }
};
</script>

<style scoped>

.dialog.dialog--active {
  background-color: white !important;
}
.jumbotron {
  padding: 0;
}
.modal-card {
  background-color: white !important;
}

::v-deep .carousel__item {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #f5f5f5;
}

.modal-carousel-side {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  background-color: #f5f5f5;
}

.modal-carousel {
  width: 100%;
  height: 380px;
}

.modal-info-side {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px 24px;
  background-color: white;
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #111;
  margin-bottom: 8px;
}

.modal-subtitle {
  color: #555;
  margin-bottom: 12px;
}

.tools-label {
  font-weight: 700;
}

.modal-actions {
  margin-top: 16px;
}

.view-site-btn {
  display: inline-block;
  padding: 8px 20px;
  background-color: crimson;
  color: white;
  text-decoration: none;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 1px;
  border-radius: 3px;
  transition: background-color 0.2s;
}

.view-site-btn:hover {
  background-color: #a00020;
}

.portP {
  color: black;
}

@media only screen and (max-width: 600px) {
  .modal-carousel {
    height: 240px;
  }

  .modal-carousel-side,
  .modal-info-side {
    padding: 16px;
  }
}

.portfolio h2 {
  text-transform: uppercase;
  letter-spacing: 5px;
  color: #000;
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  margin-top: -145px;
  margin-bottom: 100px;
}

section#portfolio .col-md-3 {
  float: left;
}

section#portfolio .col-md-9 {
  float: left;
}

.portfolio_item.work-grid {
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02);
}

.portfolio_container img {
  width: 100%;
  min-height: 182px;
  object-fit: cover;
}

.portfolio .categories-grid .categories ul li a:before {
  background: #fff;
  border-radius: 10px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.25);
  content: '';
  height: 6px;
  left: 10px;
  position: absolute;
  width: 6px;
  top: 10px;
}

.portfolio .categories-grid .categories ul li a:after {
  background: #fafafa;
  border-bottom: 13px solid transparent;
  border-left: 10px solid #eee;
  border-top: 13px solid transparent;
  content: '';
  position: absolute;
  right: 0;
  top: 0;
}

.portfolio .categories-grid .categories ul li a:hover,
.portfolio .categories-grid .categories ul li a.active {
  background-color: crimson;
  color: white;
}

.portfolio .categories-grid .categories ul li a {
  background: #eee;
  border-radius: 3px 0 0 3px;
  color: #999;
  display: inline-block;
  height: 26px;
  line-height: 26px;
  padding: 0 20px 0 23px;
  position: relative;
  margin: 0 10px 10px 0;
  text-decoration: none;
  transition: color 0.2s ease;
}

.portfolio .categories-grid .categories ul li a:hover::after,
.portfolio .categories-grid .categories ul li a.active:after {
  border-left-color: crimson;
  width: auto;
}

ul.portfolio_filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
}

.portfolio .categories-grid .categories ul li {
  list-style: none;
  margin: 7px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Portfolio.vue